import React from 'react'
import { Dropdown, Header, Icon } from 'semantic-ui-react'

let options = []
const vals=[l.show_all, 50, 75, 100, 125, 150] 
for(let i=0;i<vals.length;i++){
  options.push({
    key: 'z'+vals[i],
    text: i == 0 ? vals[i] : '% '+vals[i],
    value: i == 0 ? 0 : vals[i]/100,
    content: vals[i],
  })
}

const Zoom = (props) => (
  <div style={{display: 'inline-block'}}>
  <Header as='h6' style={{display: 'inline-block',  marginBottom: -5 , paddingLeft: 0, paddingRight: 0, width: 70, color: '#ffffff'}}>
    <Icon name='zoom' />
    <Header.Content style={{paddingLeft: 0}}>
      
      <Dropdown
        inline
        onChange= {props.zoomMenuChange}
        header={l.adjust_board_zoom}
        options={options}
        defaultValue={options[0].value}
      />
    </Header.Content>
  </Header>
  </div>
)

export default Zoom
